import React, { FC, useCallback, useState } from 'react';
import { Box, Button, buttonClasses } from '@mui/material';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import { transition } from '../../theme';
import Confetti from 'react-confetti';

const FeedbackButton: FC = () => {
  const [isFeedbackActive, setIsFeedbackActive] = useState<boolean>(false);

  const onToggleFeedback = useCallback(() => {
    setIsFeedbackActive((prev) => !prev);
  }, [setIsFeedbackActive]);

  return (
    <Box component="span">
      <Button
        color={isFeedbackActive ? 'primary' : 'inherit'}
        startIcon={
          <ThumbUpAltOutlinedIcon
            fontSize="small"
            sx={{
              transition: transition(),
            }}
          />
        }
        variant={isFeedbackActive ? 'contained' : 'text'}
        onClick={onToggleFeedback}
        sx={{
          opacity: 0.5,
          whiteSpace: 'nowrap',
          transition: transition(),
          '&:hover': {
            opacity: 1,
            [`& .${buttonClasses.startIcon}`]: {
              color: ({ palette }) => palette.primary.main,
            },
          },
          [`& .${buttonClasses.startIcon}`]: {
            marginLeft: ({ spacing }) => spacing(0.75),
          },
        }}
      >
        איך נוכל להשתפר?
      </Button>
      {isFeedbackActive && (
        <Confetti
          numberOfPieces={2500}
          recycle={false}
          style={{ zIndex: 9999 }}
          onConfettiComplete={() => setIsFeedbackActive(false)}
        />
      )}
    </Box>
  );
};

export default FeedbackButton;
